import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GoiGroupSelector from './GoiGroupSelector';
import './goi.css';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { Close, LayersOutlined } from '@mui/icons-material';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { Popup } from '@/components/common/Popup';

export default function LayersButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating button */}
      {!open && (
        <IconButton
          className={`layers-button ${isPhoneOrHighScreen() && 'phone-layers-button'}`}
          onClick={() => setOpen((prev) => !prev)}
          style={{
            backgroundColor: open ? 'white' : 'var(--mui-palette-primary-main)',
            color: open ? 'var(--mui-palette-text-primary)' : 'white',
          }}
        >
          <LayersOutlined />
        </IconButton>
      )}

      {/* Expanded panel */}
      {open &&
        (isPhoneOrHighScreen() ? (
          <Popup
            popupTitle={t('filter.goiGroupSelector')}
            header={undefined}
            body={
              <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <GoiGroupSelector />
              </Box>
            }
            footer={undefined}
            closePopup={async () => {
              setOpen((prev) => !prev);
            }}
            showCloseButton
            isFullScr
            leftText
          />
        ) : (
          <Stack className="layers-panel layers-panel-desktop">
            <Box className="panel-header">
              <Typography variant="h6">{t('filter.goiGroupSelector')}</Typography>
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{ color: 'var(--mui-palette-text-primary)' }}
                data-qa-element-id="popup-close-button"
                className="goi-group-close-button"
              >
                <Close />
              </IconButton>
            </Box>

            <Stack className="goi-group-list">
              <GoiGroupSelector />
            </Stack>
          </Stack>
        ))}
    </>
  );
}
